import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { isEmptyObject } from 'jquery';
import ReactNotification, { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import MUIDataTable from 'mui-datatables';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import { MuiThemeProvider } from '@material-ui/core';
import { getMuiTheme, tableOptions } from '../../util/MuiTableTheme';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import Services from '../../services/service';
import { MODALACTION, RESPONSE } from '../../config/constants';
import './FormModule.css';

const { CREATE, EDIT, DELETE } = MODALACTION;
const { SUCCESS, FAILED } = RESPONSE;
const dayList = ["MON","TUE","WED","THU","FRI","SAT","SUN"];

class FormModule extends Component {

  constructor(props){
    super(props);
    this.state = {
      modalAdd: false,
      moduleName: '',
      aliasName: '',
      active: '',
      dataModule: [],
      dataAsset: [],
      assetRemap: [],
      actionModal: '',
      selectedItem: {},
      divisionList: [],
      scheduleTypeList: [],
      division: '',
      scheduleType: '',
      assetId: '',
      selectedTimeRemainderList: [],
      currentHour: '',
      selectedDayRemainderList: [],
      confirmationModal: false,
      startDate: '',
      startDateValue: '',
      endDate: '',
      profileData: {},
    }
  }

  componentDidMount(){
    this.getCoreData();
    this.getParam('divisionList', 'division');
    this.getParam('scheduleTypeList', 'schedule-type');
  }

  getCoreData = () => {
    this.getDataModule();
    this.getDataAsset();
    this.getUserProfile();
  }

  addNotification = (notificationType, notificationTitle, notificationMessage, notificationPosition) => {
		store.addNotification({
			title: notificationTitle,
			message: notificationMessage,
			type: notificationType,
			insert: "top",
			container: notificationPosition,
			animationIn: ["animated", "fadeIn"],
			animationOut: ["animated", "fadeOut"],
			dismiss: { duration: 2000 },
			dismissable: { click: true }
		});
	}

  toggleNotification = action => {
    switch(action){
      case SUCCESS:
        this.addNotification('success', 'Success', 'All your data has been successfully updated', 'top-right');
        break;
      case FAILED:
        this.addNotification('danger', 'Danger', 'Oops something went wrong !', 'top-right');
        break;
      default:
        break;
    }
  };

  toggleConfirmationModal = () => {
    this.setState({
      confirmationModal: !this.state.confirmationModal,
      startDate: '',
      endDate: '',
    })
  }

  getUserProfile = () => {
    Services.getUserProfile()
      .then(res => {
        this.setState({
          profileData: res
        });
      })
      .catch(err => console.log(err));
  }

  getDataAsset = () => {
    Services.getAsset()
      .then(res => {
        this.setState({dataAsset: res}, this.dataAssetRemap(res));
      })
      .catch(err => console.log(err))
  };

  dataAssetRemap = (data) => {
    const assetRemap = [];

    data.forEach(item => {
      assetRemap.push({
        value: item._id,
        label: item.name
      })
    })

    this.setState({assetRemap: assetRemap})
  };

  getDataModule = () => {
    Services.getModule()
      .then(res => {
        this.setState({dataModule: res});
      })
      .catch(err => console.log(err))
  }

  getParam = (key, param) => {
    const payload = {
      "param": param
    };

    Services.getList(payload)
      .then(res => {
        const state = { [key]: res };
        this.setState(state)
      })
      .catch(err => console.log(err));
  }

  handleSubmitData = () => {
    const { moduleName, aliasName, active, scheduleType, assetId, selectedTimeRemainderList, selectedDayRemainderList, startDate, endDate } = this.state;
    const payload = {
      moduleName,
      aliasName,
      active,
      scheduleType,
      assetId,
      selectedTimeRemainderList,
      selectedDayRemainderList,
      startDate,
      endDate,
    };

    Services.postModule(payload)
      .then(res => {
        this.setState({modalAdd: false, startDate: '', endDate: ''});
        this.toggleNotification(SUCCESS);
        this.getDataModule();
      })
      .catch(err => {
        console.log(err);
        this.setState({modalAdd: false, startDate: '', endDate: ''});
        this.toggleNotification(FAILED);
      });
  };

  handleSubmitCloneModule = () => {
    const { selectedItem } = this.state;
    const payload = { formId : selectedItem._id };

    Services.postCloneModule(payload)
      .then(res => {
        this.toggleNotification(SUCCESS);
        this.toggleConfirmationModal();
        this.getCoreData();
      })
      .catch(err => {
        this.toggleNotification(FAILED);
        this.toggleConfirmationModal();
        console.log(err)});
  };

  handleUpdateData = () => {
    const { moduleName, aliasName, active, selectedItem, division, scheduleType, assetId, selectedTimeRemainderList, selectedDayRemainderList, startDate, endDate } = this.state;
    const payload = {
      moduleName: moduleName !== '' ? moduleName : selectedItem.moduleName,
      aliasName: aliasName !== '' ? aliasName : selectedItem.aliasName,
      active: active !== '' ? active : selectedItem.active,
      division: division !== '' ? division : selectedItem.division,
      scheduleType: scheduleType !== '' ? scheduleType : selectedItem.scheduleType,
      assetId: assetId !== '' ? assetId : selectedItem.assetId,
      selectedTimeRemainderList: selectedTimeRemainderList.length > 0 ? selectedTimeRemainderList : selectedItem.selectedTimeRemainderList,
      selectedDayRemainderList: selectedDayRemainderList.length > 0 ? selectedDayRemainderList : selectedItem.selectedDayRemainderList,
      startDate: startDate !== '' ? startDate : selectedItem.startDate,
      endDate: endDate !== '' ? endDate : selectedItem.endDate,
    };

    const param = selectedItem.aliasName;

    Services.updateModule(payload, param)
      .then(res => {
        this.setState({modalAdd: false, startDate: '', endDate: ''});
        this.toggleNotification(SUCCESS);
        this.getDataModule();
      })
      .catch(err => {
        console.log(err);
        this.setState({modalAdd: false, startDate: '', endDate: ''});
        this.toggleNotification(FAILED);
      });
  };

  handleDeleteData = () => {
    const { selectedItem } = this.state;
    const payload = selectedItem.aliasName;

    Services.deleteModule(payload)
    .then(res => {
      this.setState({modalAdd: false, startDate: '', endDate: ''});
      this.toggleNotification(SUCCESS);
      this.getDataModule();
    })
    .catch(err => {
      console.log(err);
      this.setState({modalAdd: false, startDate: '', endDate: ''});
      this.toggleNotification(FAILED);
    });
  };

  handleFieldChange = (key) => (e) => {
    if( key==='moduleName' ) {
      const state = { [key]: e.target.value, aliasName: e.target.value.replace(/\s/g, '_').toLowerCase() };
      this.setState(state);
    } else {
      const state = { [key]: e.target.value };
      this.setState(state);
    }
  }

  handleFieldChangeAsset = (key) => (e) => {
    const state = { [key]: e.value };
    this.setState(state);
  }

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Form Module</li>
      </ol>
      <h1 className="page-header">Form Module </h1>
    </div>
  );

  renderFormModuleTable = () => {
    const { dataModule } = this.state;

    return (
      <div className="col-xl-12">
        <Panel>
          <PanelHeader noButton={true}>
            <div className="d-flex justify-content-xl-between">
              <h5>Module List</h5>
              <button className="btn btn-sm btn-primary width-70" onClick={() => this.toggleAddModal(CREATE)}>Add</button>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="table-responsive">
              <table className="table table-striped m-b-0">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Module Name</th>
                    <th>Alias Name</th>
                    <th>Active</th>
                    <th width="1%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    dataModule.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index+1}</td>
                          <td>{item.moduleName}</td>
                          <td>{item.aliasName}</td>
                          <td>{item.active ?  "True" : "False"}</td>
                          <td className="with-btn text-nowrap">
                            <Link
                              to={{
                                pathname: '/checklistmanagement/form-submodule',
                                state: {
                                  selectedItem: item
                                }
                              }}
                            ><button className="btn btn-sm btn-lime width-60 m-r-2">Detail</button></Link>
                            <button
                              className="btn btn-sm btn-primary width-60 m-r-2"
                              onClick={()=> this.toggleAddModal(EDIT, item)}
                            >Edit</button>
                            <button
                              className="btn btn-sm btn-danger width-60"
                              onClick={()=> this.toggleAddModal(DELETE, item)}
                            >Delete</button>
                          </td>
                        </tr>
                      )
                    })
                  }

                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    )
  };

  renderModuleTable = () => {
    const { dataModule } = this.state;

    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "moduleName",
        label: "Module Name",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "aliasName",
        label: "Alias Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "divisionName",
        label: "Division",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "scheduleTypeName",
        label: "Schedule Type",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "active",
        label: "Active",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => value ? "True" : "False"
        }
      },
      {
        name: "_id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { minWidth: "200px", maxWidth: "400px" }}),
          customBodyRender: (value, tableMeta) => {
            return (
              <div className="with-btn text-nowrap">
              <Link
                to={{
                  pathname: '/checklistmanagement/form-submodule',
                  state: {
                    selectedItem: dataModule.find(item => item._id === value)
                  }
                }}
              ><button className="btn btn-sm btn-lime width-60 m-r-2">Detail</button></Link>
              <button
                className="btn btn-sm btn-warning width-60 m-r-2"
                onClick={()=> this.setState({ selectedItem: dataModule.find(item => item._id === value) }, this.toggleConfirmationModal)}
              >Clone</button>
              <button
                className="btn btn-sm btn-primary width-60 m-r-2"
                onClick={()=> this.toggleAddModal(EDIT, dataModule.find(item => item._id === value))}
              >Edit</button>
              <button
                className="btn btn-sm btn-danger width-60"
                onClick={()=> this.toggleAddModal(DELETE, dataModule.find(item => item._id === value))}
              >Delete</button>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      ...tableOptions,
      customToolbar: () => (
        <button className="btn btn-sm btn-primary width-70" onClick={() => this.toggleAddModal(CREATE)}>Add</button>
      ),

    };

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"List Module"}
          data={dataModule}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    )
  };

  //Start Modal Method

  toggleAddModal = (action = '', item = {}) => {
    if(action === 'EDIT') {
      this.setState({
        modalAdd: !this.state.modalAdd,
        actionModal: action,
        selectedItem: item,
        moduleName: item.moduleName,
        aliasName: '',
        active: '',
        division: '',
        scheduleType: '',
        startDate: '',
        endDate: '',
        selectedTimeRemainderList: item.selectedTimeRemainderList
      });
    } else {
      this.setState({
        modalAdd: !this.state.modalAdd,
        actionModal: action,
        selectedItem: item,
        moduleName: '',
        aliasName: '',
        active: '',
        division: '',
        scheduleType: '',
        startDate: '',
        endDate: '',
        selectedTimeRemainderList: item?.selectedTimeRemainderList? item.selectedTimeRemainderList : []
      });
    }
  }

  renderAddModuleModal = () => {
    const {
      actionModal,
      selectedItem,
      moduleName,
      // aliasName,
      active,
      division,
      divisionList,
      scheduleTypeList,
      scheduleType,
      assetId,
      assetRemap,
      selectedTimeRemainderList,
      currentHour,
      selectedDayRemainderList,
      profileData,
    } = this.state;
    const textHeader = this.setHeaderItemText(actionModal);
    const filled = isEmptyObject(selectedItem);
    const isHarian = !filled && scheduleType === '' ? selectedItem.scheduleType === '6155d7eeedb2db85a210805c' : scheduleType === '6155d7eeedb2db85a210805c';
    const isChecktrue = !isEmptyObject(profileData) ? profileData?.createFormChecklist : false;
    const divisionDefaultValue = !isChecktrue && profileData?.division;

    // const selectedDay = filled && selectedDayRemainderList.length === 0
    //   ? selectedItem.selectedDayRemainderList === undefined ? [] : selectedItem.selectedDayRemainderList
    //   : selectedDayRemainderList;

    let selectedDay;

    if (!filled && selectedDayRemainderList.length === 0) {
      if (selectedItem.selectedDayRemainderList === undefined) {
        selectedDay = []
      } else {
        selectedDay = selectedItem.selectedDayRemainderList;
      }
    } else {
      selectedDay = selectedDayRemainderList;
    }

    let selectedAsset = [];

    if (!filled) {
      selectedAsset = assetRemap.filter(item => item.value === selectedItem.assetId)
    }

    return (
      <Modal isOpen={this.state.modalAdd} toggle={() => this.toggleAddModal()}>
        <ModalHeader toggle={() => this.toggleAddModal()}>{textHeader}</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Module Name</label>
            <input
              onChange={this.handleFieldChange('moduleName')}
              type="text"
              className="form-control"
              defaultValue={!filled ? selectedItem.moduleName : moduleName}
              disabled={actionModal === DELETE}
            />
          </div>
          <div className="form-group">
            <label>Alias Name</label>
            <input
              readOnly
              type="text" className="form-control"
              value={ moduleName.replace(/\s/g, '_').toLowerCase() }
              disabled={actionModal === DELETE}
            />
          </div>
          <div className="form-group">
            <label>Division</label>
            <select
              onChange={this.handleFieldChange('division')}
              className="form-control"
              placeholder="Select Option"
              defaultValue={!filled ? selectedItem.division : divisionDefaultValue ?? division}
              disabled={actionModal === DELETE || !isChecktrue}
            >
              <option value="">Select Option</option>
              {
                divisionList.map((item, idx) => {
                  return <option key={idx} value={item.id}>{item.label}</option>
                })
              }
            </select>
          </div>
          <div className="form-group">
            <label>Schedule Type</label>
            <select
              onChange={this.handleFieldChange('scheduleType')}
              className="form-control"
              placeholder="Select Option"
              defaultValue={!filled ? selectedItem.scheduleType : scheduleType}
              disabled={actionModal === DELETE}
            >
              <option value="">Select Option</option>
              {
                scheduleTypeList.map((item, idx) => {
                  return <option key={idx} value={item.id}>{item.name}</option>
                })
              }
            </select>
          </div>

          { isHarian && (
            <>
              <div className="form-group">
                <label>Choose Day</label>
                <div className="container">
                  {isHarian &&
                    dayList.map((item, idx) => {
                      const isChecked = selectedDay.includes(item);
                      return (
                        <div key={idx} style={{ margin: "12px", display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                          <input type="checkbox" id={idx} name={item} value={item} checked={isChecked} onChange={this.handleAddDay} />
                          <label style={{ marginLeft: "2px" }} htmlFor={item}>{item}</label>
                        </div>
                      );
                    })}
                  {!isHarian &&
                    dayList.map((item, idx) => {
                      const isChecked = selectedDay.includes(item);
                      return (
                        <div key={idx} style={{ margin: "12px", display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                          <input type="radio" id={idx} name={"radiooptions"} value={item} checked={isChecked} onChange={this.handleAddDay} />
                          <label style={{ marginLeft: "2px" }} htmlFor={item}>{item}</label>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div>
                <div className="form-group">
                  <label>Hour</label>
                  <div className="container">
                    <input
                      onChange={this.handleFieldChange('currentHour')}
                      type="time"
                      className="form-control"
                      value={currentHour}
                      // defaultValue={!filled ? selectedItem.startHour : startHour}
                      disabled={actionModal === DELETE} />
                    <button className="btn-primary" onClick={this.handleAddHour}>Add</button>
                  </div>
                </div>
                <div className="form-group">
                  <div className="container d-flex flex-wrap">
                      {selectedTimeRemainderList.map((tag, index) =>
                          <div key={index} className="tag">
                            {tag}
                            {(actionModal === DELETE) ? 
                              (<button style={{cursor: 'default'}}>&nbsp;</button>)
                              :
                              (<button onClick={() => this.handleDeleteHour(index)}>x</button>)
                            }
                          </div>
                      )}
                    </div>
                  </div>
              </div>
            </>

          )}

          { !isHarian && (
            <>
            {this.renderFilterDateSection(!filled)}
            <div className="form-group">
              <label>Hour</label>
              <div className="container d-flex flex-wrap">
                <input
                  onChange={this.handleFieldChange('currentHour')}
                  type="time"
                  className="form-control"
                  value={currentHour}
                  // defaultValue={!filled ? selectedItem.startHour : startHour}
                  disabled={actionModal === DELETE}
                />
                <button className="btn-primary" onClick={this.handleSingleAddHour}>Add</button>
              </div>
            </div>
            <div className="form-group">
              <div className="container">
                  {selectedTimeRemainderList.map((tag, index) =>
                      <div key={index} className="tag">
                        {tag}
                        {(actionModal === DELETE) ? 
                          (<button style={{cursor: 'default'}}>&nbsp;</button>)
                          :
                          (<button onClick={() => this.handleDeleteHour(index)}>x</button>)
                        }
                      </div>
                  )}
                </div>
              </div>
            </>
          )
          }
          {/* <div className="form-group">
            <label>Choose Day</label>
            <div className="container">
              { isHarian &&
                dayList.map((item, idx) => {
                const isChecked = selectedDay.includes(item);
                return (
                  <div key={idx} style={{margin: "12px", display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
                    <input type="checkbox" id={idx} name={item} value={item} checked={isChecked} onChange={this.handleAddDay} />
                    <label style={{marginLeft: "2px"}} htmlFor={item}>{item}</label>
                  </div>
                )
                })
              }
              { !isHarian &&
              dayList.map((item, idx) => {
                const isChecked = selectedDay.includes(item);
                return (
                  <div key={idx} style={{margin: "12px", display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
                    <input type="radio" id={idx} name={"radiooptions"} value={item} checked={isChecked} onChange={this.handleAddDay} />
                    <label style={{marginLeft: "2px"}} htmlFor={item}>{item}</label>
                  </div>
                )
              })
              }
            </div>
          </div>
          <div>
            <div className="form-group">
              <label>Hour</label>
              <div className="container">
                <input
                  onChange={this.handleFieldChange('currentHour')}
                  type="time"
                  className="form-control"
                  value={currentHour}
                  // defaultValue={!filled ? selectedItem.startHour : startHour}
                  disabled={actionModal === DELETE}
                />
                <button className="btn-primary" onClick={this.handleAddHour}>Add</button>
              </div>
            </div>
            <div className="form-group">
              <div className="container">
                {selectedTimeRemainderList.map((tag, index) =>
                    <div key={index} className="tag">
                      {tag}
                      {(actionModal === DELETE) ? 
                        (<button style={{cursor: 'default'}}>&nbsp;</button>)
                        :
                        (<button onClick={() => this.handleDeleteHour(index)}>x</button>)
                      }
                    </div>
                )}
              </div>
            </div>
          </div> */}
          {/* {isHarian && (
          <div>
            <div className="form-group">
            <label>Start Hour</label>
              {startHour.map((tag) => <div className="tag">{startHour}</div>)}
              <input
                onChange={this.handleFieldChange('startHour')}
                type="time"
                className="form-control"
                // defaultValue={!filled ? selectedItem.startHour : startHour}
                disabled={actionModal === DELETE}
                required
              />
            </div>
            <div className="form-group">
            <label>End Hour</label>
              <input
                onChange={this.handleFieldChange('endHour')}
                type="time"
                className="form-control"
                defaultValue={!filled ? selectedItem.endHour : endHour}
                disabled={actionModal === DELETE}
                required
              />
            </div>
          </div>
          )} */}

          <div className="form-group">
            <label>Asset</label>
            <Select
              onChange={this.handleFieldChangeAsset('assetId')}
              defaultValue={!filled ? selectedAsset : assetId}
              // isDisabled={isDisabled}
              // isSearchable={true}
              options={assetRemap}
            />
            {/* <select
              onChange={this.handleFieldChange('asset')}
              className="form-control"
              placeholder="Select Option"
              // defaultValue={!filled ? selectedItem.asset : scheduleType}
              disabled={actionModal === DELETE}
            >
              <option value="">Select Option</option>
              {
                dataAsset.map((item, idx) => {
                  return <option key={idx} value={item.id}>{item.name}</option>
                })
              }
            </select> */}
          </div>
          <div className="form-group">
            <label>Active</label>
            <select
              onChange={this.handleFieldChange('active')}
              className="form-control"
              defaultValue={!filled ? selectedItem.active : active}
              disabled={actionModal === DELETE}
            >
              <option value="">Select Option</option>
              <option value="true">True</option>
              <option value="false">False</option>
            </select>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleAddModal()}>Cancel</button>
          <button className="btn btn-primary" onClick={()=> this.setActionButton(actionModal)}>{actionModal}</button>
        </ModalFooter>
      </Modal>
    )
  }

  renderConfirmationModal = () => {
    const { confirmationModal } = this.state;
    return (
      <Modal isOpen={confirmationModal} toggle={() => this.toggleConfirmationModal()}>
        <ModalHeader toggle={() => this.toggleConfirmationModal()}>Confirmation</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <h3>Are you sure ?</h3>
          </div>

        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={this.handleSubmitCloneModule}>Yes</button>
          <button className="btn btn-danger" onClick={this.toggleConfirmationModal}>No</button>
        </ModalFooter>
      </Modal>
    )
  }

  handleAddHour = () => {
    const { selectedTimeRemainderList, currentHour } = this.state;

    if(currentHour !== '') {
      const listHour = [...selectedTimeRemainderList, currentHour];

      this.setState({
        selectedTimeRemainderList: listHour,
        currentHour: ''
      });
    };
  };

  handleSingleAddHour = () => {
    const { currentHour } = this.state;

    if(currentHour !== '') {
      const listHour = [currentHour];

      this.setState({
        selectedTimeRemainderList: listHour,
      });
    };
  };

  handleDeleteHour = (idx) => {
    this.setState({ selectedTimeRemainderList: this.state.selectedTimeRemainderList.filter((tag, i) => i !== idx)});
  };

  handleAddDay = e => {
    const { selectedDayRemainderList } = this.state;
    const isChecked = selectedDayRemainderList.includes(e.target.value);
    let selectedDay = [];
    if (isChecked) {
      selectedDay = selectedDayRemainderList.filter(item => item !== e.target.value);
    } else {
      selectedDay = [...selectedDayRemainderList, e.target.value];
    }

    this.setState({ selectedDayRemainderList: selectedDay });
  };

  setHeaderItemText = (value) => {
    switch (value) {
      case CREATE :
        return 'Add Module';
      case EDIT :
        return 'Edit Module';
      case DELETE :
        return 'Are you sure want to delete ?';
      default:
        return '';
    }
  }

  setActionButton = (value) => {
    switch (value) {
      case CREATE :
        this.handleSubmitData();
        break;
      case EDIT :
        this.handleUpdateData();
        break;
      case DELETE :
        this.handleDeleteData();
        break;
      default:
        break;
    }
  }

  //End Modal Method
  _renderDatePickerStart = (filled, isCreate) => (
    <DatePicker
      className="form-control"
      value={filled && !isCreate && !this.state.startDate ? this.state.selectedItem.startDate : this.state.startDate}
      placeholderText="Click to select start Date"
      onChange={value => 
        this.setState({ 
          startDate: moment(value).format('DD-MM-YYYY'),
          startDateValue: value,
        })
      }
      onCalendarClose={this.getDataComplaint}
    />
  );

  _renderDatePickerEnd = (filled, isCreate) => (
    <DatePicker
      className="form-control"
      value={filled && !isCreate && !this.state.endDate ? this.state.selectedItem.endDate : this.state.endDate}
      placeholderText="Click to select end Date"
      onChange={value => this.setState({ endDate: moment(value).format('DD-MM-YYYY') })}
      minDate={this.state.startDateValue}
      onCalendarClose={this.getDataComplaint}
    />
  );
  
  renderFilterDateSection = (filled) => {
    const { actionModal } = this.state;
    return (
    <div className="form-group row">
      <div>
        <label>Select Start Date</label>
        <div className="container">
          {this._renderDatePickerStart(filled, actionModal === CREATE)}
        </div>
      </div>
      <div>
        <label>Select End Date</label>
        <div className="container">
          {this._renderDatePickerEnd(filled, actionModal === CREATE)}
        </div>
      </div>
    </div>
  )};  

  render() {
    return (
      <div>
        <ReactNotification/>
        {this.renderBreadcrumb()}
          {/* {this.renderFormModuleTable()} */}
        {this.renderModuleTable()}
        {this.renderAddModuleModal()}
        {this.renderConfirmationModal()}
      </div>
    )
  }
};

export default FormModule;
